import { useFormikContext } from "formik"
import React, { ReactNode, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { useApiContext } from "~/api"
import { AttachFileField } from "~/components/AttachFile/AttachFile"
import { FormCheckbox } from "~/components/Checkbox/Checkbox"
import { Form } from "~/components/Form/Form"
import { FormSubmitSection } from "~/components/FormSubmitSection/FormSubmitSection"
import { Heading } from "~/components/Heading/Heading"
import { FormInput } from "~/components/Input/Input"
import { Raw } from "~/components/raw"
import { FormSelect } from "~/components/Select/Select"

import styles from "./index.module.css"

type Option = {
  value: string
  label: ReactNode
}

const Content: React.FC = () => {
  const { t } = useTranslation()
  const categories = useApiContext("/procurementcategories/list")
  const { values, setFieldValue } = useFormikContext()
  const { isLikeAddressLegal, legalAdress } = values as any

  const formattedCategories = categories.reduce((prev: Option[], curr) => {
    prev.push({ value: curr.name, label: curr.name })

    return prev
  }, [])

  useEffect(() => {
    if (!isLikeAddressLegal) return

    setFieldValue("actualAdress", isLikeAddressLegal ? legalAdress : "")
  }, [isLikeAddressLegal, legalAdress, setFieldValue])

  return (
    <>
      <Heading className={styles.Title} like="h3">
        <Raw html={t("submit-application.Form.Title.01")} />
      </Heading>

      <FormSelect
        name="procurementCategory"
        options={formattedCategories}
        placeholder={"Выберите категорию закупки"}
      />

      <FormInput label={t("submit-application.Form.nameCompany")} name="companyName" />

      <div className={styles.Double}>
        <FormInput label={t("submit-application.Form.tin")} name="inn" />

        <FormInput label={t("submit-application.Form.psrn")} name="ogrn" />
      </div>

      <FormInput label={t("submit-application.Form.phoneCompany")} name="phoneCompany" />

      <FormInput label={t("submit-application.Form.directorGeneralName")} name="director" />

      <FormInput label={t("submit-application.Form.emailCompany")} name="emailCompany" />

      <FormInput label={t("submit-application.Form.addressLegal")} name="legalAdress" />

      <FormInput
        disabled={isLikeAddressLegal}
        label={t("submit-application.Form.addressPhysical")}
        name="actualAdress"
      />

      <div className={styles.Checkbox}>
        <FormCheckbox
          label={t("submit-application.Form.isLikeAddressLegal")}
          name="isLikeAddressLegal"
        />
      </div>

      <FormInput label={t("submit-application.Form.webSite")} name="link" />

      <AttachFileField />

      <Heading className={styles.Title} like="h3">
        <Raw html={t("submit-application.Form.Title.02")} />
      </Heading>

      <FormInput label={t("popup.Default.Form.Fio.Label")} name="contactName" />

      <FormInput label={t("submit-application.Form.position")} name="position" />

      <div className={styles.Double}>
        <FormInput label={t("popup.Default.Form.Phone.Label")} name="phone" />

        <FormInput label={t("popup.Default.Form.Email.Label")} name="email" />
      </div>

      <FormSubmitSection
        buttonLabel={t("submit-application.Form.Submit")}
        className={styles.SendWrapper}
      />
    </>
  )
}

export const FormWrapper: React.FC = () => {
  return (
    <div className={styles.Wrapper}>
      <Form
        className={styles.Form}
        initialValues={{
          procurementCategory: "",
          companyName: "",
          inn: "",
          ogrn: "",
          phoneCompany: "",
          director: "",
          emailCompany: "",
          legalAdress: "",
          actualAdress: "",
          link: "",
          contactName: "",
          position: "",
          phone: "",
          email: "",
        }}
        url="/partnershipform/submit"
      >
        <Content />
      </Form>
    </div>
  )
}
